import MainPage from "./store.container";

export default MainPage;
